import { ValueOf } from '../utilities/types';

export const thresholdModes = {
  DEFAULT_ONLY: 'defaultOnly',
  KYC_ONLY: 'kycOnly',
  BOTH: 'both',
} as const;

export type ThresholdModes = ValueOf<typeof thresholdModes>;

export const thresholdModeChoices = [
  { id: thresholdModes.DEFAULT_ONLY, name: 'Default only' },
  { id: thresholdModes.KYC_ONLY, name: 'KYC form only' },
  { id: thresholdModes.BOTH, name: 'Both' },
];

export default thresholdModes;
